import _ from 'lodash';

export default val => _.startCase(val);
